var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#1434cb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.86,16.33,12.94,25.7H10.37L8.44,18.22a1,1,0,0,0-.58-.82,9.69,9.69,0,0,0-2.39-.8l.06-.27H9.66a1.13,1.13,0,0,1,1.11,1l1,5.42,2.52-6.37Zm3.47,0H17.9l-2,9.37h2.42l2-9.37Zm6.57,6.31h0c0,1.95-1.67,3.2-4.22,3.2A7.29,7.29,0,0,1,20,25.35l.44-2.06a5,5,0,0,0,2.49.59c.69,0,1.44-.28,1.45-.91,0-.41-.32-.71-1.26-1.17S21,20.6,21,19.25c0-1.82,1.7-3.09,4.09-3.09a6.54,6.54,0,0,1,2.27.41l-.42,2a4.54,4.54,0,0,0-2.39-.42c-.7.09-1,.45-1,.78,0,1.11,3.4,1.25,3.39,3.72Zm6.33,3.06h2.24l-1.95-9.37H31.45a1.12,1.12,0,0,0-1,.68L26.78,25.7h2.54l.51-1.4h3.11l.29,1.4Zm-2.7-3.32,1.27-3.52.74,3.52Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.12108f84ec3d420072256ea79c3db75e.svg";
export { ForwardRef as ReactComponent };